<template>
  <div
    class="row flex-center tableTopSelet"
    :class="{ 'is-disabled': disabled }"
  >
    <div class="leftname" v-if="showLeftName">{{ leftname }}</div>
    <div class="flex-1">
      <el-cascader
        class="multiple-select fw100"
        v-model="self[modelval]"
        :options="selectTreeOptions"
        :show-all-levels="false"
        :placeholder="placeholder"
        :filter-method="deptFilter"
        filterable
        :size="size"
        v-bind="$attrs"
        collapse-tags
        :props="{
          expandTrigger: 'hover',
          emitPath: false,
          multiple: false,
          checkStrictly,
          value: 'id',
          label: 'departmentName',
          children: 'children',
        }"
        @change="changeDept"
      >
      </el-cascader>
    </div>
  </div>
</template>

<script>
import { getWecomWorkplaceDeptTree } from "@/api/options.js";
import PinyinMatch from "pinyin-match";
import func from "@/util/func";

export default {
  name: "YGJDeptCascader",
  props: {
    self: {
      type: Object,
      required: true,
      default: () => ({}),
    },
    modelval: {
      type: String,
      required: true,
    },
    checkStrictly: {
      type: Boolean,
      default: true,
    },
    showLeftName: {
      type: Boolean,
      default: true,
    },
    size: {
      type: String,
      default: "default",
    },
    leftname: {
      type: String,
      default: "",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: "请选择",
    },
  },
  components: {},
  data() {
    return {
      selectTreeOptions: [],
    };
  },
  mounted() {
    this.getDeptTree();
  },
  methods: {
    judgeHasChildren(arr1) {
      let arr = arr1;
      for (let i = 0; i < arr.length; i++) {
        if (arr[i].children && arr[i].children.length > 0) {
          this.judgeHasChildren(arr[i].children);
        } else {
          arr[i].children = undefined;
        }
      }
      return arr;
    },
    getDeptTree() {
      getWecomWorkplaceDeptTree().then((res) => {
        const deptRes = res?.data?.data || [];
        this.$emit("treeLoaded", func.copyArr(deptRes));
        this.selectTreeOptions = this.judgeHasChildren(deptRes);
      });
    },
    deptFilter(node, val) {
      let m = PinyinMatch.match(node.label, val);
      if (m) {
        return true;
      }
    },
    changeDept(id) {
      const ids = this.getDepartmentIdsSubtree(id);
      /**
       * id: 当前选中的节点id
       * ids: 当前节点和所有子节点id
       */
      this.$emit("deptChange", { id, ids });
    },
    //返回当前节点和所有子节点id
    getDepartmentIdsSubtree(id, nodes = this.selectTreeOptions) {
      for (const node of nodes) {
        if (node.id === id) {
          const collect = (n) => {
            const ids = [n.id];
            if (Array.isArray(n.children)) {
              n.children.forEach((child) => ids.push(...collect(child)));
            }
            return ids;
          };
          return collect(node);
        }
        if (Array.isArray(node.children)) {
          const found = this.getDepartmentIdsSubtree(id, node.children);
          if (found.length) return found;
        }
      }
      return [];
    },
  },
};
</script>

<style lang="scss" scoped>
.tableTopSelet {
  font-size: 14px;
  background-color: #fff;
  &.is-disabled {
    background-color: #f5f7fa;
    .leftname {
      color: #c0c4cc;
      background-color: #fff;
    }
  }
  .leftname {
    text-align: right;
    font-size: 13px;
    line-height: 30px;
    color: #666;
    margin-right: 12px;
    background-color: #fff;
  }

  padding: 0px 0px 0px 12px;
  border-radius: 4px;
  border: 1px solid #e6e6e6;
}

:deep(.el-input__inner) {
  border-top-left-radius: 0px;
  border-bottom-left-radius: 0px;
  border: none;
  padding-left: 0px;
  line-height: 32px;
  height: 30px;
  color: #333;
}

:deep(.el-input__wrapper) {
  box-shadow: none !important;
}

:deep(.el-select) {
  border: none;
}

:deep(.el-input) {
  border: none;
}

:deep(.el-input.is-focus) {
  border: none;
}

:deep(.el-input__inner:hover) {
  border: none;
}

:deep(.el-select .el-input.is-focus .el-input__inner) {
  border: none;
}

:deep(.el-radio-button__inner) {
  border-top-right-radius: 0px;
  border-bottom-right-radius: 0px;
  border: none;
}
</style>
